import {
  assignmentSchema,
  insightsResponseSchema,
  parentOverviewSchema,
  type Assignment,
  type AssignmentListQuery,
  type Page,
  type InsightsResponse,
  type ParentOverview,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** Everything the parent console renders, in one call. */
export async function fetchParentOverview(): Promise<ParentOverview> {
  return parentOverviewSchema.parse(await apiFetch<unknown>('/parent/overview'));
}

/** Work belonging to every teen this guardian is verified for. [Parent 14-16] */
export function fetchWardAssignments(
  query: Partial<AssignmentListQuery> = {},
): Promise<Page<Assignment>> {
  return fetchPage('/parent/assignments', assignmentSchema, query);
}

/** How it is going, per teen. [Parent step 23] */
export async function fetchInsights(): Promise<InsightsResponse> {
  return insightsResponseSchema.parse(await apiFetch<unknown>('/parent/insights'));
}

/**
 * A guardian signing off that their teen's finished work matched what was
 * asked. [Parent step 18]
 *
 * Advisory: it does not approve the work for the employer and it does not move
 * the payment. It puts the family's confirmation on the record and tells the
 * employer, which is what "confirm with job poster" asks for.
 */
export async function confirmWardCompletion(assignmentId: string): Promise<Assignment> {
  return assignmentSchema.parse(
    await post<unknown>(`/parent/assignments/${assignmentId}/confirm`, {}),
  );
}
